module.exports = __webpack_public_path__ + "static/media/Partner14.3dcb07be.webp";